export default {
  APP_TITLE: process.env.VUE_APP_TITLE,

  URL: process.env.VUE_APP_URL,
  API_URL: process.env.VUE_APP_API_URL,
  RESOURCE_URL: process.env.VUE_APP_RESOURCE_URL,

  report_type: {
    "financial": "Periodic Financial",
    "narative": "Periodic Narrative", 
    "final_financial": "Final Financial",
    "final_narative": "Final Narrative"
  },
  report_status: {
    "pending": "Pending",
    "processing": "Processing", 
    "accepted": "Accepted",
    "rejected": "Rejected"
  },
  report_status_color: {
    "pending": "secondary",
    "processing": "info",
    "accepted": "success", 
    "rejected": "danger"
  }
}